import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

/**
 * CurlyBracesIcon
 *
 * Inline SVG version with correct proportions and stroke settings.
 * Drop-in compatible with Material-UI v4 icons.
 */
export const CurlyBracesIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ overflow: 'visible' }} // prevent clipping or squish
    >
        <path d="M9.5 5H9a2 2 0 0 0-2 2v2c0 1-.6 3-3 3 1 0 3 .6 3 3v2a2 2 0 0 0 2 2h.5m5-14h.5a2 2 0 0 1 2 2v2c0 1 .6 3 3 3-1 0-3 .6-3 3v2a2 2 0 0 1-2 2h-.5" />
    </SvgIcon>
);
